module.exports = __webpack_public_path__ + "static/media/group-10.99f90297.svg";